// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistant',
  },
  close: {
    amigo: 'Close Amigo',
    assistant: 'Close the assistant',
  },
  brand: 'Brand',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chats',
  new_chat: 'New chat',
  back: 'Back to the chat',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'New answers in another chat',
  news_elsewhere_other: 'New answers in {{count}} other chats',
};
